import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00315 = new TileLayer({
  title: 'Máscara 19990912',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990912l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00315.setVisible(false);

const layer00314 = new TileLayer({
  title: 'Máscara 19991107',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19991107l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00314.setVisible(false);

const layer00313 = new TileLayer({
  title: 'Máscara 19991115',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19991115l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00313.setVisible(false);

const layer00312 = new TileLayer({
  title: 'Máscara 19991123',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19991123l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00312.setVisible(false);

const layer00311 = new TileLayer({
  title: 'Máscara 19991217',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19991217l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00311.setVisible(false);

const layer00310 = new TileLayer({
  title: 'Máscara 20000118',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000118l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00310.setVisible(false);

const layer00309 = new TileLayer({
  title: 'Máscara 20000203',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000203l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00309.setVisible(false);

const layer00308 = new TileLayer({
  title: 'Máscara 20000219',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000219l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00308.setVisible(false);

const layer00307 = new TileLayer({
  title: 'Máscara 20000525',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000525l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00307.setVisible(false);

const layer00306 = new TileLayer({
  title: 'Máscara 20000602',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000602l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00306.setVisible(false);

const layer00305 = new TileLayer({
  title: 'Máscara 20000712',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000712l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00305.setVisible(false);

const layer00304 = new TileLayer({
  title: 'Máscara 20000813',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20000813l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00304.setVisible(false);

export const grupoCapa01_22 = new LayerGroup({
  title: 'Ciclo Hidrológico 1999-2000',
  fold: 'close',
  layers: [layer00304, layer00305, layer00306, layer00307, layer00308, layer00309, layer00310, layer00311, layer00312, layer00313, layer00314, layer00315]
});